import { apiClient } from "./client";

/**
 * Policy Generator API - generates TRONC policy documents from live config.
 */
export const policyGeneratorApi = {
  /**
   * Generate a policy document for the current tenant.
   * @param {string} [ruleId] - Optional rule ID to generate for a specific rule
   * @param {string} [date] - Optional date (YYYY-MM-DD) to load eligibility + distribution rule effective on that date
   */
  generate(ruleId = null, date = null) {
    const params = new URLSearchParams();
    if (ruleId) params.set("ruleId", ruleId);
    if (date) params.set("date", date);
    const qs = params.toString();
    return apiClient.get(`/policygenerator${qs ? `?${qs}` : ""}`);
  },

  /**
   * Generate a policy preview with custom eligibility rules (what-if).
   * @param {object} [eligibilityRules] - Custom eligibility rules
   * @param {string} [ruleId] - Optional rule ID
   * @param {string} [date] - Optional date (YYYY-MM-DD)
   */
  preview(eligibilityRules = null, ruleId = null, date = null) {
    const params = new URLSearchParams();
    if (ruleId) params.set("ruleId", ruleId);
    if (date) params.set("date", date);
    const qs = params.toString();
    return apiClient.post(`/policygenerator/preview${qs ? `?${qs}` : ""}`, eligibilityRules);
  },
};

export default policyGeneratorApi;
